<ng-container *ngIf="configuration">
    <p-floatLabel>
        <h4 [for]="configuration.Id" class="mb-3 mt-4">{{configuration.Label}}</h4>
        <input pInputText [type]="configuration.Type" [id]="configuration.Id" [formControl]="configuration.Control"/>
    </p-floatLabel>
</ng-container>
